import { ApplicationType } from "interfaces/models/ApplicationType";
import IUserApplicationDetails from "interfaces/models/IUserApplicationDetails";
import IGroupResponseItem from "interfaces/responses/IGroupResponseItem";
import IUserApplicationResponseItem from "interfaces/responses/IUserApplicationsResponseItem";

const mapUserApplicationsResponseItemToUserApplication = (userApplicationResponseItem : IUserApplicationResponseItem, groups : IGroupResponseItem[])
: IUserApplicationDetails => {
  const userApplicationDetails : IUserApplicationDetails = {
    group: {
      groupId: userApplicationResponseItem.application.group,
      groupName: groups.find(group => group.id === userApplicationResponseItem.application.group)?.name ?? userApplicationResponseItem.application.group
    },
    isAllocated: userApplicationResponseItem.allocated,
    applicationDetails: {
      applicationId: userApplicationResponseItem.application.id,
      environment: userApplicationResponseItem.application.environment,
      siteUrl: userApplicationResponseItem.application.baseUrl,
      applicationType: ApplicationType[userApplicationResponseItem.application.type as keyof typeof ApplicationType]
    }
  };

  return userApplicationDetails;
};

export { mapUserApplicationsResponseItemToUserApplication };
